import { ReactNode } from 'react'
import HugeTitle from '../atoms/HugeTitle'
import SmallTitle from '../atoms/SmallTitle'

interface Props {
  upper: string | ReactNode
  main: string
}

const DoubleHeader: React.FC<Props> = ({ upper, main }) => {
  return (
    <div className="mb-8">
      <SmallTitle>{upper}</SmallTitle>
      <HugeTitle>{main}</HugeTitle>
    </div>
  )
}

export default DoubleHeader
